import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

export class About extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    Index: 0,
  }
  componentDidMount() {
    this.props.actions.fetchGetWebSite().then(res => {
      if (res.SuccessResponse) {
        this.setState({
          Index: res.Data[0].ID,
        })
      }
    });
  }
  render() {
    const { fetchGetWebSiteSuccess } = this.props.common;
    const { Index } = this.state;
    if (!fetchGetWebSiteSuccess) return null;
    let Data = fetchGetWebSiteSuccess;
    let Content = Data.filter(it => { return it.ID === Index });
    return (
      <div className="common-about">
        <div className="common-about-content">
          <div className="menu">
            <ul>
              {
                Data.map(item => (
                  <li key={item.ID} className={Index === item.ID ? "item-active" : "item"} onClick={() => {
                    this.setState({
                      Index: item.ID,
                    })
                  }}>{item.Name}</li>
                ))
              }
            </ul>
          </div>
          {
            Content.length > 0 && <div className="content">
              <h1>{Content[0].Name}</h1>
              <div className="inner" dangerouslySetInnerHTML={{ __html: Content[0].Content }} />
            </div>
          }
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(About);



// WEBPACK FOOTER //
// ./src/features/common/About.js